import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const EmailDashboardApi = createApi({
  reducerPath: "EmailDashboard",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    // dashboardType: "overview" | "performance" | "analytics" | "sentiments"
    emailDashboard: builder.query({
      query: ({
        dashboardType,
        selectedTeam,
        graphStartDate,
        graphEndDate,
      }: {
        dashboardType: string;
        selectedTeam: string | number;
        graphStartDate: string;
        graphEndDate: string;
      }) => {
        const params: Record<string, string | number> = {
          start_date: graphStartDate,
          end_date:   graphEndDate,
          team:       selectedTeam,
        };

        return {
          url:    `v1/common/emailDashboard/${dashboardType}/`,
          method: "GET",
          params,
        };
      },
    }),

    getEmailClickToExpand: builder.query({
      query: ({
        graph_name,
        value,
        start_date,
        end_date,
        team_id,
        page,
        page_size,
        email_type,
      }: {
        graph_name:  string;
        value:       string;
        start_date:  string;
        end_date:    string;
        team_id:     string | number;
        page?:       number;
        page_size?:  number;
        email_type?: string;
      }) => {
        const params: Record<string, string | number> = {
          graph_name,
          value,
          start_date,
          end_date,
          team:      team_id,
          page:      page      ?? 1,
          page_size: page_size ?? 20,
        };
        if (email_type != null && email_type !== "") {
          params.email_type = email_type;
        }
        return {
          url:    `v1/common/emailDashboard/click-to-expand/`,
          method: "GET",
          params,
        };
      },
    }),
  }),
});

export const {
  useEmailDashboardQuery,
  useGetEmailClickToExpandQuery,
} = EmailDashboardApi;